/* eslint-disable */
import { CHEVRON_DOWN_24, CHEVRON_UP_24 } from "@sznds/icons";
import createSDSIcon from "~/ui/icon";
import { node } from "~/util/dom";
import { _ } from "~/i18n";

interface IOption {
	title: string;
	value: any;
}

interface ISortBoxOptions {
	options: Array<IOption>;
	onSelect?: any
	onOpen?: any
	selectedIndex?: number;
	onSelectLog?: any;
}

export default class SortBox {
	_container: HTMLDivElement;
	_onSelect: Function;
	_onOpen: Function;
	_button: HTMLButtonElement;
	_buttonText: HTMLSpanElement;
	_menu: HTMLUListElement;
	_options: Array<IOption>;

	constructor({ options = [], onSelect, onOpen, selectedIndex = 0 }: ISortBoxOptions) {
		this._container = node("div", { className: `ui-sortbox` });
		this._onSelect = onSelect;
		this._onOpen = onOpen;
		this._build(options, selectedIndex);
		this._options = options;
		window.addEventListener("click", this, false);
		this._button.addEventListener("click", this, false);
	}

	destroy() {
		window.removeEventListener("click", this, false);
		this._button.removeEventListener("click", this, false);
	}

	get node() {
		return this._container;
	}

	set value(value) {
		this._options.forEach(option => {
			if (value === option.value) {
				this._buttonText.innerHTML = _(option.title);
			}
		})
	}

	handleEvent(event: Event) {
		if (event.currentTarget === this._button && !this._menu.parentNode) {
			event.stopPropagation();
			this._container.appendChild(this._menu);
			this._button.classList.add("open");
			this._onOpen && this._onOpen();
		} else {
			// mozna vybral neco z menu
			try {
				const menuItem = (event.target as HTMLElement).closest(".ui-sortbox__menu li");

				if (menuItem && this._menu.contains(menuItem)) {
					const index = parseInt(menuItem.getAttribute("data-index"));
					const option = this._options[index];

					this._buttonText.innerHTML = _(option.title);

					this._onSelect && this._onSelect(option.value, option);
				}
			} catch(error) {
				// error
			}

			this._button.classList.remove("open");
			this._menu.remove();
		}
	}

	_build(options: Array<IOption>, selectedIndex: number) {
		const button = node("button", { type: "button", className: "ui-sortbox__button" });
		const buttonText = node("span", { className: "ui-sortbox__buttontext", innerHTML: _(options[selectedIndex].title) });

		button.appendChild(buttonText);
		const downIcon = createSDSIcon({
			symbol: CHEVRON_DOWN_24,
		});
		downIcon.classList.add("down-icon");
		const upIcon = createSDSIcon({
			symbol: CHEVRON_UP_24,
		});
		upIcon.classList.add("up-icon");
		button.appendChild(downIcon);
		button.appendChild(upIcon);
		button.setAttribute("data-log-ignore", "1");

		this._container.appendChild(button);

		this._menu = node("ul", { className: "ui-sortbox__menu" });
		options.forEach((option, index) => {
			const opt = node("li", { innerHTML: _(option.title) });

			opt.setAttribute("data-index", index.toString());
			this._menu.appendChild(opt);
		});

		this._button = button;
		this._buttonText = buttonText;
	}
}
